export class ScheduleDStepTwoConstants {
    /**
     * Old structure type that must be changed for all new submissions.
     */
    static readonly StructureTypeTower = 'TOWER';
}
